export const reports = {
    route: '报告',
    overAll: '整体',
    byDevice: '按设备',
    reportTitle: '该报告是从监控器中按月获取的信息:',
    compare: '上个月能耗与前一个月相比:',
    kwhMissing: '请输入APP账户/设置下的每千瓦时的价格',
    monthlyConsumption: '每月能耗(千瓦时):',
    mostRelevant: '最相关使用:',
    alwaysOn: '一直运行的设备',
    graphTips: '在这张图上,橙色线显示您在一天中的哪个时间(x轴)和一个月中的哪个日期(Y轴)使用了设备.',
    deviceReport: '设备能耗:',
    savingPotentials: '节能潜力',
    myAvgKwh: '设备过去30天总的电力消耗',
    avgKwh: '相同设备类型的范围',
    myAvgW: '设备瓦数',
    avgW: '相同设备类型的范围',
    kwh: '千瓦时',
    euro: '元',
    costUnit: '元'
};
